import { Link } from "@tanstack/react-router";
import type { NowCardData } from "@signet/web-kit";

/* Domains whose live links are not being served, from the hourly sweep (server/lib/watch.ts).
   Drawn only with Signet's kit classes: a links stylesheet imported here would
   be applied to every page (tests/look.test.ts). */

type Data = { total: number; liveLinks: number; domains: { id: string; hostname: string; status: string; error: string | null; liveLinks: number }[] };

const STATUS: Record<string, string> = {
  misconfigured: "not reaching the runtime",
  pending_dns: "does not resolve",
  provisioning: "no certificate yet",
  migrating: "mid-migration",
};

export function DomainsNowCard({ card }: { card: NowCardData }) {
  const data = card.data as Data;
  return (
    <section className="panel now-card attention">
      <div className="panel-head">
        <h2>{card.title}</h2>
      </div>
      <div className="panel-body">
        <p className="now-figure tabular">{data.liveLinks}</p>
        <p className="muted">
          live {data.liveLinks === 1 ? "link" : "links"} on {data.total} {data.total === 1 ? "domain" : "domains"} that the last check could not reach.
        </p>
        <ul className="now-list">
          {data.domains.map((d) => (
            <li key={d.id}>
              {d.hostname}: {STATUS[d.status] ?? d.status}, {d.liveLinks} {d.liveLinks === 1 ? "link" : "links"}
              {d.error ? <><br /><span className="muted">{d.error}</span></> : null}
            </li>
          ))}
        </ul>
        <Link to={"/links/domains" as never} search={(data.domains.length === 1 ? { open: data.domains[0]!.id } : {}) as never} className="text-button tiny accent">
          Open domains
        </Link>
      </div>
    </section>
  );
}
